$(document).ready(function () {

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * cursor from https://css-tricks.com/next-level-css-styling-for-cursors/
    // *
    // *
    const $cursor = $(".cursor");

    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;

    if (!isTouchDevice && !prefersReducedMotion && $cursor.length) {
        // Show our custom cursor
        $cursor.css("display", "block");

        // Inject CSS to hide the default cursor
        $("<style>").text(`
        * {
            cursor: none;
        }
    `).appendTo("head");

        // Position cursor div to cursor position
        $(document).on("mousemove", function (e) {
            let x = e.clientX;
            let y = e.clientY;
            $cursor.css({
                left: x + "px",
                top: y + "px"
            });
        });

        // Add 'click' class to cursor on mousedown and remove on mouseup
        $(document).on("mousedown", function () {
            $cursor.addClass("click");
        });

        $(document).on("mouseup", function () {
            $cursor.removeClass("click");
        });

        // Add 'pressable' class to cursor when hovering certain elements
        $(document).on("mouseover", "a, button", function () {
            $cursor.addClass("pressable");
        });

        $(document).on("mouseleave", "a, button", function () {
            $cursor.removeClass("pressable");
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-mobilenav").toggleClass("active");
        $("body").toggleClass("freeze");
        $(".js-circle-background").toggleClass("active")
        $(".js-header").toggleClass("navOpen");
    });


    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-mobilenav").removeClass("active");
            $(".js-navbutton").removeClass("active");
            $(".js-circle-background").removeClass("active");
            $(".js-header").removeClass("navOpen");
            $("body").removeClass("freeze");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * duoSlider
    // *
    // *
    var $duoSlider = $(".js-duo-slider");

    if ($duoSlider.length) {
        $duoSlider.each(function () {
            $(this).find(".js-duo-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                slidesToShow: 2,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: false,
                prevArrow: $(this).find(".js-duo-slider-prev"),
                nextArrow: $(this).find(".js-duo-slider-next"),
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    }
                ],
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    var $sliderWrapper = $(".js-slider");
    if ($sliderWrapper.length) {
        $sliderWrapper.each(function () {

            var $slider = $(this).find(".js-slider-track");
            $slider.slick({
                rows: 0,
            });

            var $filterButton = $(this).find(".js-filter-slider-button");
            $filterButton.on('click', function () {
                $(this).addClass("active");
                $(this).siblings(".js-filter-slider-button").removeClass("active");

                var filter = $(this).data('filter');
                $slider.slick('slickUnfilter');

                if (filter === 'all') {
                    $slider.slick('slickUnfilter');
                } else {
                    // Use attribute selector to filter
                    $slider.slick('slickFilter', `[data-filter="${filter}"]`);
                }
            })
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hero animation
    // *
    // *
    var heroAnimationState = sessionStorage.getItem('heroAnimationShown');
    var $heroAnimation = $(".js-hero-animation");
    if (!heroAnimationState && $heroAnimation.length > 0) {
        // User has seen it before - hide it
        sessionStorage.setItem('heroAnimationShown', 'true');
        $heroAnimation.addClass("slide-up");
    }
    else {
        $heroAnimation.hide();
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    $(".js-open-dialog").click(function () {
        openModal();
    })
    $(".js-close-dialog").click(function () {
        closeModal();
    })
    var $dialog = $(".js-dialog");
    var dialogState = sessionStorage.getItem('dialogState');

    function openModal() {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

    function closeModal() {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $dialog.get(0).close();
        $("body").removeClass("freeze");
    }

    $(".js-close-dialog").click(function () {
        closeModal();
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    });

    if (!dialogState && $dialog.length > 0) {
        openModal();
    }



    $(".js-to-top").click(function () {
        $(window).scrollTop(0);
    })


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hide header on scroll down, show on scroll up
    // *
    // *
    var $header = $('.js-header');
    var lastScrollTop = 0;
    var SCROLL_THRESHOLD = 50;

    function showHeader() {
        $header.addClass('show');
    }

    // Scroll
    $(window).on('scroll', function () {
        var currentScrollTop = $(this).scrollTop();

        // Only apply behavior after scrolling past threshold
        if (currentScrollTop >= SCROLL_THRESHOLD) {
            // Scrolling down - show header
            if (window.innerWidth > 1000) {
                if (currentScrollTop > lastScrollTop) {
                    showHeader();
                }
                // on mobile hide header after delay
            } else {
                showHeader();
                resetHideTimer();
            }

        }
        lastScrollTop = currentScrollTop;
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hide header after delay
    // *
    // *
    var hideTimeout = null;
    var isHovered = false;

    var HIDE_DELAY = 500;

    function hideHeader() {
        if (isHovered) return;

        $header.removeClass('show')
    }

    function resetHideTimer() {
        clearTimeout(hideTimeout);

        if (!isHovered) {
            hideTimeout = setTimeout(hideHeader, HIDE_DELAY);
        }
    }


});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 200) {
        $(".js-to-top").addClass("show");
    } else {
        $(".js-to-top").removeClass("show");
    }

    if ($(window).scrollTop() >= 50) {
        $(".js-hideonscrolltop").addClass("show");
    }
});
